import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { CompleteIeltsTraining } from "@modules/elearning/lead";

const ElearningDetails = () => {
  return (
    <LayoutMain
      footer_with_evaluation
      title="The Complete IELTS Training Program"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/elearning/the-complete-IELTS-training-program`}
    >
      <CompleteIeltsTraining />
    </LayoutMain>
  );
};

export default ElearningDetails;
